export default __webpack_public_path__ + "static/media/arrow-blue.9c81d2c8.svg";